import type { ComponentType } from "react";
import type { RouteObject } from "react-router";

/** What a file under `src/routes` may export for the router to read. */
export type RouteModule = Readonly<{
  action?: RouteObject["action"];
  default?: ComponentType;
  ErrorBoundary?: ComponentType;
  handle?: unknown;
  HydrateFallback?: ComponentType;
  loader?: RouteObject["loader"];
  shouldRevalidate?: RouteObject["shouldRevalidate"];
}>;

/**
 * The route object the generated route table hands React Router for a route
 * module. An export left out here never reaches the router, however well the
 * module's own tests exercise it.
 */
export const moduleToRoute = (module: RouteModule) => ({
  action: module.action,
  handle: module.handle,
  loader: module.loader,
  shouldRevalidate: module.shouldRevalidate,
  Component: module.default,
  ErrorBoundary: module.ErrorBoundary,
  HydrateFallback: module.HydrateFallback,
});
